<template>
  <v-card class="v-register text-center">
    <v-card-title>
      <v-row justify="center">
        <LeadtributorCloudIconColor/>
      </v-row>
    </v-card-title>
    <v-card-subtitle>
      <h1>{{$t('login.registerTitle')}}</h1>
    </v-card-subtitle>
    <div class="description">{{$t('login.registerSubtitle')}}</div>
    <v-text-field outlined v-model="loginComputed" :error-messages="value.emailAlreadyUsed ? [$t('login.emailAlreadyUsedError')] : []">
      <template v-slot:label>
        {{$t('login.email')}}
      </template>
    </v-text-field>
    <v-text-field outlined type="password" v-model="passwordComputed">
      <template v-slot:label>
        {{$t('login.password')}}
      </template>
    </v-text-field>
    <v-text-field outlined type="password" :rules="passwordRules" v-model="repeatPassword">
      <template v-slot:label>
        {{$t('login.repeatPassword')}}
      </template>
    </v-text-field>
    <ButtonPrimaryDark @click="emitRegisterEvent">
      <template v-slot:text>{{$t('login.register')}}</template>
    </ButtonPrimaryDark>
    <v-card-text class="text-left pt-2 pb-2 px-0">
        <slot name="privacy"></slot>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text class="text-left pt-1 pb-0 px-0">
      <v-row
        align="center"
        justify="space-around"
      >
        <slot></slot>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import LeadtributorCloudIconColor from '@/components/icons/LeadtributorCloudIconColor'
import ButtonPrimaryDark from '@/components/buttons/templates/ButtonPrimary'
import { computed, ref } from '@vue/composition-api'
import { injectLocalization } from '@/plugins/localization'

export default {
  name: 'RegisterComponent',
  props: {
    value:{
      type: Object,
      default: function () {
        return {
          login: '',
          password: '',
          emailAlreadyUsed: false
        }
      }
    }
  },
  components: {
    ButtonPrimaryDark,
    LeadtributorCloudIconColor
  },
  setup (props, { emit }) {

    const loginComputed = computed({
      get: () => props.value.login,
      set: (login) => {
        let value = props.value
        value.login = login
        value.emailAlreadyUsed = false
        emit('input', value)
      }
    })
    const passwordComputed = computed({
      get: () => props.value.password,
      set: (password) => {
        let value = props.value
        value.password = password
        emit('input', value)
      }
    })

    const repeatPassword = ref('');

    function emitRegisterEvent () {
      if(passwordComputed.value === repeatPassword.value) {
        emit('register', props.value)
      }
    }

    const translate = injectLocalization();
    const passwordMatchError = translate('login.passwordMatchError')
    const passwordRules = [(passwdRepeat) => passwordComputed.value === passwdRepeat || passwordMatchError]

    return {
      loginComputed,
      passwordComputed,
      repeatPassword,
      passwordRules,
      emitRegisterEvent
    }
  }
}
</script>

<style lang="scss">
  .v-register {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    padding: 24px 32px 32px;
    margin: 0 auto;
    max-width: 338px;

    .v-card__subtitle {
      margin-top: 32px;
    }

    h1 {
      color: #3E4041;
      font-size: 30px;
      font-weight: 300;
      line-height: 38px;
    }

    .description {
      color: #8EA2A8;
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 32px;
    }

    .small {
      color: #8EA2A8;
      font-size: 14px;
      line-height: 17px;
      margin-top: 24px;
      margin-bottom: 16px;
    }

    .v-card__text {
      color: #8EA2A8;
      font-size: 14px;
      line-height: 17px;
    }
  }
</style>

<style lang="scss">
  .v-register {
    .v-input {
      flex: none;

      &::after {
        display: none;
      }
    }

    .v-input__control {
      margin-bottom: 32px;
    }

    .v-label {
      font-size: 18px;
      line-height: 14px;
    }

    .v-divider {
      margin-top: auto;
    }

    .v-card__text {
      a {
        color: #8EA2A8;
        text-decoration: underline;
      }
    }
  }
</style>
